require('angular')
require('../flash/flash-module')
require('../session/session-module') # use for call api
AuthInterceptor = require('./auth-interceptor')
AuthLocationInterceptor = require('./auth-location-interceptor')
AuthService = require('./auth-service')

modules = [
  'gnp-flash',
  'gnp-session'
  'ngCookies'
]
angular.module 'gnp-auth', modules
  .config ['$httpProvider', ($httpProvider) ->
    $httpProvider.interceptors.push('AuthInterceptor')
  ]
  .factory 'AuthInterceptor', AuthInterceptor
  .factory 'AuthService', AuthService
  .value 'returnUrl',
    url: '/',
    external: false
  .run AuthLocationInterceptor




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/auth/auth-module.coffee